import axiosToken from "../../api/axiosClient";
import { buildQueryString } from "../../utils/reportUtils";

class AppointmentReportService {
  /**
   * Récupère les statistiques des rendez-vous
   */
  async getStats(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/appointments/stats${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  /**
   * Récupère la liste des rendez-vous
   */
  async getList(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/appointments/list${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  /**
   * Récupère les rendez-vous annulés
   */
  async getCancelled(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/appointments/cancelled${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  /**
   * Récupère la liste d'attente
   */
  async getWaitingList(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/appointments/waiting-list${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  _handleError(error) {
    return {
      message: error.response?.data?.error || "Erreur rendez-vous",
      status: error.response?.status,
    };
  }
}

export default new AppointmentReportService();
